import { NSARouterMakerResult, NSABoxSecret } from "namirasoft-account-react";
import { BasicAuthCreateRow, BasicAuthRow } from "namirasoft-credential";
import { NSBox, NSBoxString, NSBoxTextArea, NSColumn, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { CredentialEntities } from "../CredentialEntities";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialProps } from "../CredentialProps";

interface BasicAuthEditPageProps extends NSARouterMakerResult, CredentialProps
{
    isEdit: boolean;
}

export default class BasicAuthEditPage extends Component<BasicAuthEditPageProps>
{
    NSBoxString_Name = createRef<NSBoxString>();
    NSABoxSecret_Username = createRef<NSABoxSecret>();
    NSABoxSecret_Password = createRef<NSABoxSecret>();
    NSBoxTextArea_Description = createRef<NSBoxTextArea>();

    override render()
    {
        return (
            <CredentialLayout<BasicAuthRow, BasicAuthCreateRow>
                {...this.props}
                action={{
                    description: this.props.isEdit ? "This section allows you to edit a Basic Auth credential by updating its name, username, password, or description. The username and password are kept as protected secrets, and any application set up to use the credential applies the updated values." : "This section allows you to create a Basic Auth credential for services that use HTTP basic authentication by entering a username and password. Namirasoft encrypts the sensitive data for secure access, and any Namirasoft application you set up to use it can then sign in to those services.",
                }}
                pages={{
                    entity: CredentialEntities.basic_auth(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): BasicAuthCreateRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let username = this.NSABoxSecret_Username.current?.getValue() ?? "";
                                        let password = this.NSABoxSecret_Password.current?.getValue() ?? "";
                                        let description = this.NSBoxTextArea_Description.current?.getValue() ?? "";

                                        return {
                                            workspace_id: "",
                                            name,
                                            username,
                                            password,
                                            description,
                                            basic_auth_category: [],
                                            basic_auth_field: [],
                                            basic_auth_tag: [],
                                        };
                                    },
                                    setRow: (row: BasicAuthRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSABoxSecret_Username.current?.setValue(row.username_secret_id);
                                        this.NSABoxSecret_Password.current?.setValue(row.password_secret_id);
                                        this.NSBoxTextArea_Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString
                        ref={this.NSBoxString_Name}
                        required
                        title="Name"
                        auto_complete="new-password"
                        style={{ width: NSBox.width.double }}
                    />
                    <NSRow>
                        <NSABoxSecret
                            {...this.props}
                            ref={this.NSABoxSecret_Username}
                            required
                            title="User Name"
                            auto_complete="new-password"
                        />
                        <NSABoxSecret
                            {...this.props}
                            ref={this.NSABoxSecret_Password}
                            required
                            title="Password"
                            auto_complete="new-password"
                        />
                    </NSRow>
                    <NSRow>
                        <NSBoxTextArea
                            ref={this.NSBoxTextArea_Description}
                            required={false}
                            title="Description"
                            style={{ width: NSBox.width.double }}
                        />
                    </NSRow>
                </NSColumn>
            </CredentialLayout >
        );
    }
}